<template>
  <div>
    <CruiseItineraryInfo
      class="tw-mb-6"
      :cruise-index="cruiseIndex"
      :text-labels="textLabels"
      :arrival-time="arrivalTime"
      :departure-time="departureTime"
      :destination-name="destinationName"
      :items-length="cruiseData && cruiseData.length"
      :desktop-only="true"
      :is-sea-day="isSeaDay"
    />
    <div>
      <div class="tw-mb-4 sm:tw-mb-6">
        <VueImage
          class="tw-mb-3.5"
          width="100%"
          height="100%"
          :src="itineraryLogo"
          :alt="textLabels && textLabels.cruiseCardLogoAltLabel"
        />
        <div
          v-if="!isDesktopLg"
          class="
            tw-flex tw-justify-between tw-flex-col
            sm:tw-flex-row
            tw-mb-3.5
          "
        >
          <div
            class="
              tw-text-center tw-font-semibold
              sm:tw-font-bold
              tw-leading-6 tw-text-lg tw-mb-2
              sm:tw-mb-0
            "
          >
            {{
              textLabels &&
              textLabels.cruiseTabsLabelsDesktop &&
              textLabels.cruiseTabsLabelsDesktop.cruiseModalTabsItineraryLabel
            }}
          </div>
          <slot name="cruise-info"></slot>
        </div>
        <div class="tw-text-sm" v-html="itinerarySummary"></div>
      </div>
      <div v-if="!isDesktopLg" class="tw-col-span-12">
        <ItineraryCard
          v-for="(card, index) in cruiseData"
          :key="index"
          :card-data="card"
          :text-labels="textLabels"
          :current-day="index + 1"
          :arrival-time="arrivalTime"
          :departure-time="departureTime"
          :is-desktop-sm="isDesktopSm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CruiseItineraryInfo from "@/stories/Components/CruiseItineraryDetail/Elements/desktop/CruiseItineraryInfo/CruiseItineraryInfo.vue";
import { EventBus } from "@/helpers/event-bus";
import VueImage from "@/stories/Atoms/VueImage/VueImage.vue";
import ItineraryCard from "@/stories/Components/CruiseItineraryDetail/Elements/ItineraryCard/ItineraryCard";

export default {
  name: "CruiseItineraryTab",

  components: { ItineraryCard, VueImage, CruiseItineraryInfo },

  props: {
    cruiseData: {
      type: Array,
      default: () => [],
      required: true,
    },
    cruiseIndex: {
      type: Number,
      required: true,
      default: 0,
    },
    textLabels: {
      type: Object,
      required: true,
      default: () => {},
    },
    isDesktopLg: {
      type: Boolean,
      default: false,
      required: true,
    },
    isDesktopSm: {
      type: Boolean,
      default: false,
      required: true,
    },
    logoMobile: {
      type: String,
      default: "false",
      required: false,
    },
    logoDesktop: {
      type: String,
      default: "false",
      required: false,
    },
    cruiseDescriptionTablet: {
      type: String,
      default: "",
      required: false,
    },
  },

  computed: {
    itineraryLogo() {
      return (
        (this.isDesktopLg
          ? this.cruiseData?.[this.cruiseIndex]?.Images.Desktop
          : this.isDesktopSm
          ? this.logoDesktop
          : this.logoMobile) ||
        require("@/assets/images/sea-day-placeholder-desktop.jpg")
      );
    },
    arrivalTime() {
      return this.cruiseData?.[this.cruiseIndex]?.ArrivalTime;
    },
    departureTime() {
      return this.cruiseData?.[this.cruiseIndex]?.DepartureTime;
    },
    destinationName() {
      return this.cruiseData?.[this.cruiseIndex]?.Name;
    },
    isSeaDay() {
      return this.cruiseData?.[this.cruiseIndex]?.IsSeaDay;
    },
    itinerarySummary() {
      return this.isDesktopLg
        ? this.cruiseData?.[this.cruiseIndex]?.Summary
        : this.cruiseDescriptionTablet;
    },
  },

  methods: {
    changeDay(changeType) {
      EventBus.$emit("changeDate", changeType);
    },
  },
};
</script>
